export class TooManyRequestsError extends Error {
  constructor() {
    super('Muitas tentativas. Aguarde 1 minuto.');
    this.name = 'TooManyRequestsError';
  }
}
